import { getAction, postAction } from '@/utils/request'
//import {ca, it} from 'vuetify/locale'

/**
 * 经销商数据 获取产品信息列表
 * 返回模型
 * {
 *   “product_grp_brand_product”:[
 *     {
 *       "product_group","PH" label
 *       "brand","品牌 如 拜瑞妥"
 *       "product","产品 如 拜瑞妥 6*20mg"
 *     },
 *     {
 *       "product_group","PH"
 *       "brand","品牌 如 拜瑞妥"
 *       "product","产品 如 拜瑞妥 8*20mg"
 *     },
 *     {
 *       "product_group","RAD"
 *       "brand","品牌 如 拜瑞妥"
 *       "product","产品 如 拜瑞妥 10*20mg"
 *     }
 *   ]
 * }
 * [
 * {
 *   "label":"PH",
 *   "value":"PH",
 *   "children":[
 *     {
 *       "label":"拜瑞妥",
 *       "value":"拜瑞妥",
 *       "children":[
 *         {
 *           "label":"拜瑞妥 10*20mg",
 *           "value":"拜瑞妥 10*20mg"
 *         },
 *         {
 *           "label":"拜瑞妥 10*20mg",
 *           "value":"拜瑞妥 10*20mg"
 *         },
 *         {
 *           "label":"拜瑞妥 10*20mg",
 *           "value":"拜瑞妥 10*20mg"
 *         },
 *         {
 *           "label":"拜瑞妥 10*20mg",
 *           "value":"拜瑞妥 10*20mg"
 *         },
 *         {
 *           "label":"拜瑞妥 10*20mg",
 *           "value":"拜瑞妥 10*20mg"
 *         },
 *       ]
 *     }
 *   ]
 *
 *
 * }]
 */
/**
 *
 * @param data {{'product_grp_brand_product':[{'product_group':'','brand':'',product:''}]}}
 * @returns {*[]}
 */
function transProducts(data) {
  let result = []
  let split = '@$%'
  let arr = data.productGrpBrandProduct.map((a) => a.productGroup + split + a.brand + split + a.product)
  arr.sort()
  for (const item of arr) {
    let [group, brand, product] = item.split(split)
    let exitsGroup = result.find((a) => a.label == group)
    if (!exitsGroup) {
      exitsGroup = {
        label: group,
        value: group,
        children: [],
      }
      result.push(exitsGroup)
    }

    let exitsBrand = exitsGroup.children.find((a) => a.label == brand)
    if (!exitsBrand) {
      exitsBrand = {
        label: brand,
        value: brand,
        children: [],
      }
      exitsGroup.children.push(exitsBrand)
    }
    exitsBrand.children.push({ label: product, value: product })
  }
  return result
}
/**
 *
 * @param data {{'productGrpBrandProduct':[{'productGroup':'','brand':'',product:''}]}}
 * @returns {*[]}
 */
function transProductsNew(data) {
  let result = [];
  let lastGroup;
  let lastBrand;
  for (let item of data.productGrpBrandProduct) {

    let group;
    if (lastGroup && lastGroup.label == item.productGroup) {
      group = lastGroup;
    } else {
      group = result.find(a => a.label == item.productGroup);
      if (!group) {
        group = {
          label: item.productGroup,
          value: item.productGroup,
          children: []
        };
        result.push(group);
      }
      lastGroup = group;
    }

    let brand;
    if (lastBrand && lastBrand.label == item.brand) {
      brand = lastBrand;
    } else {
      brand = group.children.find(a => a.label == item.brand);
      if (!brand) {
        brand = {
          label: item.brand,
          value: item.brand,
          children: []
        };
        group.children.push(brand);
      }
      lastBrand = brand;
    }

    brand.children.push({
      label: item.product,
      value: item.product
    });
  }
  return result;
}

export function getProductsApi() {
  return getAction('/api/v1/distributor/products', undefined, undefined).then((data) => transProductsNew(data))
}

/**
 * 经销商数据 获取经销商名称列表
 * 请求参数：cwid
 * 返回模型
 * {
 *   "distributor_names":[
 *     "上海1号经销商",
 *     "上海2号经销商",
 *     "上海3号经销商",
 *     "上海4号经销商"
 *   ]
 * }
 * @return {Promise<any>}
 */

export function getDistributorNamesApi() {
  return getAction('/api/v1/distributor/name', undefined, undefined)
}

/**
 * 经销商数据 获取问题列表
 * 返回模型
 * {
 *   “questions”:[
 *   {
 *     "category":"问题分类1",
 *     "targetQuestion":"问题1",
 *   },
 *     {
 *     "category":"问题分类1",
 *     "targetQuestion":"问题2",
 *   },
 *     {
 *     "category":"问题分类2",
 *     "targetQuestion":"问题3",
 *   }
 *   ]
 * }
 * 这里对服务器的返回模型进行了处理，同商品信息的模型 label-value-children
 */
export function getQuestionsApi() {
  return getAction('/api/v1/distributor/questions', undefined, undefined).then((a) => transQuestionsNew(a))
}

function transQuestions(data) {
  let rawQuestions = data.questions
  let result = []
  let group = { label: '', value: '', children: [] }
  result.push(group)
  let split = '@$%'
  let arr = rawQuestions.map((a) => a.category + split + a.targetQuestion)
  arr.sort()
  for (const item of arr) {
    let [category, targetQuestion] = item.split(split)
    let existCategory = group.children.find((a) => a.label == category)
    if (!existCategory) {
      existCategory = { label: category, value: category, children: [] }
      group.children.push(existCategory)
    }
    existCategory.children.push({ label: targetQuestion, value: targetQuestion })
  }
  return result
}

function transQuestionsNew(data){
  let result = [];
  let group = { label: '', value: '', children: [] }
  result.push(group);

  let lastCategory;
  let category;
  for (let item  of data.questions) {
    if (lastCategory && lastCategory.label == item.category) {
      category = lastCategory;
    } else {
      category = result.find(a => a.label == item.category);
      if (!category) {
        category = {
          label: item.category,
          value: item.category,
          children: []
        };
        group.children.push(category);
      }
      lastCategory = category;
    }
    category.children.push({label: item.targetQuestion, value: item.targetQuestion});
  }
  return result;
}

/**
 * 经销商数据 获取[选择时间]的选项
 * 返回类型
 * {
 *   "time_options":["年","季度","月","YTD"]
 * }
 * @return {Promise<any>}
 */
export function getTimeOptionsApi() {
  return getAction('/api/v1/distributor/time-options', undefined, undefined)
}

/**
 * 经销商数据 发送请求 获取对话结果
 * 请求参数模型：{
 *   “distributor”:"上海1号经销商",
 *   “product”:["拜瑞妥 10*20mg","拜瑞妥 10*20mg"]
 *   “date_span_option”:"ytd",
 *   “end_date”:"2023-06-01", -- 仅ate_span_option == ytd时有效
 *   “target_questions”:["问题3","问题3","问题3"]
 * }
 * 返回参数模型 见大模型定义 ChatResponse.ts里面
 * @return {Promise<ResponseGroupMessage>}
 */
export function sendDistributorApi(data) {
  return postAction('/api/v1/distributor/profile', data, undefined)
}
